enum EUpdateQuantityTypes {
  CART_ADD_ITEM = 'Cart/ADD_ITEM',
  CART_UPDATE_QUANTITY = 'Cart/UPDATE_QUANTITY',
  // CART_UPDATE_QUANTITY_REVERT = 'Cart/UPDATE_QUANTITY_REVERT',
  CART_UPDATE_ENTRY_DETAIL = 'Cart/UPDATE_ENTRY_DETAIL',
  CART_UPDATE_ENTRY_TOGGLE_LOADING = 'Cart/UPDATE_ENTRY_TOGGLE_LOADING',
}

export default EUpdateQuantityTypes;
